import { deepComputedFrom } from 'aurelia-deep-computed';
import { BindingEngine, bindingMode, Disposable, LogManager } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { sortProperties } from 'framework/script_utilities/object-equalizer';

export abstract class ModelBase<TModel> {
  @bindable model: TModel = null;
  @bindable mutated: () => unknown = null;
  @bindable({ defaultBindingMode: bindingMode.fromView }) changed = false;
  @bindable debug = false;
  private originalModelJson: string = null;
  private modelJsonSubscription: Disposable = null;

  constructor(protected bindingEngine: BindingEngine) { }

  bind() {
    this.modelChanged(this.model);
    this.modelJsonSubscription = this.bindingEngine.propertyObserver(this, 'modelJson').subscribe(newValue => this.modelJsonChanged(newValue));
  }

  unbind() {
    this.modelJsonSubscription.dispose();
  }

  protected modelJsonReplacer(key: string, value) {
    return sortProperties(value);
  }

  modelChanged(newValue: TModel) {
    this.originalModelJson = JSON.stringify(newValue, this.modelJsonReplacer);
    this.changed = false;
  }

  @deepComputedFrom('model')
  private get modelJson() {
    return JSON.stringify(this.model, this.modelJsonReplacer);
  }

  private modelJsonChanged(newValue: string) {
    this.changed = newValue !== this.originalModelJson;
    this.changed && this.debug && this.debugModelChange(newValue);
    this.mutated && this.mutated();
  }

  private debugModelChange(changedModelJson: string) {
    LogManager.getLogger('ModelBase').debug('Model changed', changedModelJson, this.originalModelJson);
  }
}
